import { Dialog, useTranslations } from "@harea/component";
import moment from "moment";
import { usePaymentStatusLabels } from "../../../hooks/usePaymentStatusLabels";

const PaymentDetailsDialog = ({ open, onClose, payment }: PaymentDetailsDialogProps) => {
  const [
    DETAILS,
    AMOUNT,
    TRANSACTION_DATE,
    STATUS,
    PAYMENT_METHOD,
    TRANSACTION_INFO,
    DOWNLOAD_INVOICE,
    CLOSE,
    REFERENCE,
  ] = useTranslations(i18n);
  const { STATUS_LABELS, METHOD_LABELS } = usePaymentStatusLabels();

  const status = STATUS_LABELS[payment?.status ?? ""] ?? {
    label: payment?.status ?? "-",
    className: "bg-gray-100 text-gray-700",
  };

  const method = METHOD_LABELS[payment?.paymentMethod ?? ""] ?? payment?.paymentMethod ?? "-";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={DETAILS}
      className="max-w-md"
    >
      <div className="space-y-4">
        <div className="flex justify-between items-center py-2 border-b">
          <span className="text-gray-600">{AMOUNT}</span>
          <span className="font-semibold text-lg">
            {payment?.amount !== undefined ? `${payment.amount.toLocaleString()} Ar` : "-"}
          </span>
        </div>

        <div className="flex justify-between items-center py-2 border-b">
          <span className="text-gray-600">{TRANSACTION_DATE}</span>
          <span className="font-medium">
            {payment?.paidAt ? moment(payment.paidAt).format("DD/MM/YYYY HH:mm") : "-"}
          </span>
        </div>

        <div className="flex justify-between items-center py-2 border-b">
          <span className="text-gray-600">{STATUS}</span>
          <span
            className={`px-3 py-1 rounded-full text-sm font-medium ${status.className}`}
          >
            {status.label}
          </span>
        </div>

        <div className="flex justify-between items-center py-2 border-b">
          <span className="text-gray-600">{PAYMENT_METHOD}</span>
          <span className="font-medium">{method}</span>
        </div>

        <div className="py-2 border-b">
          <span className="text-gray-600 block mb-2">{TRANSACTION_INFO}</span>
          <div className="bg-gray-50 p-3 rounded-lg">
            <div className="text-sm">
              <span className="text-gray-500">{REFERENCE}: </span>
              <span className="font-medium">{payment?.reference ?? "-"}</span>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default PaymentDetailsDialog;

type PaymentDetailsDialogProps = {
  open: boolean;
  onClose: () => void;
  payment?: any;
};

const i18n = [
  "Harea.Billing.Dialog.Details.Title",
  "std_amount",
  "Harea.Billing.Dialog.TransactionDate.Label",
  "std_status",
  "Harea.Billing.Dialog.PaymentMethod.Label",
  "Harea.Billing.Dialog.TransactionInfo.Label",
  "Harea.Billing.Dialog.DownloadInvoice.Label",
  "std_close",
  "std_reference",
];
